import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/support/page.tsx")